import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DeleteButton from '../components/DeleteButton';
import DeleteIconButton from '../components/DeleteIconButton';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Box, Button, Chip, Divider, Fab, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputLabel, LinearProgress, ListItem, ListItemText, Modal, Select, Switch, TextField, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import { makeStyles } from '@mui/styles';
import throttle from 'lodash/throttle';
import { useSnackbar } from "notistack";
import React from "react";

import { CREATE, DataAPIContext, GET_LIST, UPDATE } from "../api";
import { DELETE_BATCH } from "../api/dataProvider";
import ConfirmationDialog from "../components/ConfirmationDialog";
import PageMeta from "../components/PageMeta";
import RecordList from "../components/RecordList";
import { ContextStore } from "../store/contextStore";
import { roleChangeError as staffChangeError } from "../users/roleAccessRefusal";
import { debounce, isOk, serverErrorMessage } from "../utils";

// WP-K: /tour_operator_user/ refuses (403) what users/roleAccessRefusal.js describes; a staff removal counts as
// removing every role the member holds.
export { ROLE_ACCESS_REFUSED } from "../users/roleAccessRefusal";

function useIsWidthUp(breakpoint) {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up(breakpoint));
}

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: 0,
        margin: theme.spacing(2),
        marginTop: 0,
        height: '75vh',
        // width: '100%',
        display: 'flex',

        // height: '90%',
        // width: '100%',
        // display: 'flex',
        // marginTop: theme.spacing(1)
    },
    gridRoot: {
        flexGrow: 1,
        // margin: theme.spacing(2)
    },
    recordList: {
        marginTop: theme.spacing(2),
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },        
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    formGroup: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    chip: {
        margin: theme.spacing(1),  
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chipInSelect: {
        margin: 2,
    },
    switchLabel: {
        fontSize: 'small',
    },
    progress: {
        marginBottom: theme.spacing(1),
        // marginTop: theme.spacing(2),
    }
}));

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;

// const MenuProps = {
//     PaperProps: {
//       style: {
//         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//         width: 250,
//       },
//     },
//   };

//   const useToolbarStyles = makeStyles({
//     hidden: {
//         visibility: 'hidden',
//     },
//     grow: {
//         flexGrow: 1,
//       },
//     })

const useModalStyles = makeStyles((theme) => ({
    paper: {
        position: 'fixed',
        top: '5%',
        left: '5%',
        right: '5%',
        bottom: '5%',
        zIndex: 99001,
        [theme.breakpoints.up('md')]: {
            top: '25%',
            left: '25%',
            right: '25%',
            bottom: '25%',    
        },
        // width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #d8d8d8',
        borderRadius: '10px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    }));
      

// The Modal's child: it needs a ref to move focus into the window and back when it closes
const UserSearchModal = React.forwardRef((props, ref) => {
    const dataAPI = React.useContext(DataAPIContext);
    const classes = useModalStyles();
    const [value, setValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState([
        // { display_name: 'default option 1', id: 1 },
        // { display_name: 'default option 2', id: 2 },
    ]);

    const fetch = React.useMemo(
        () => throttle((params, cb) => {
            dataAPI(GET_LIST, "user", params)
                .then(res => cb(res));
        }, 500),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    React.useEffect(() => {
        let active = true;
        if (inputValue === '') {
            // setOptions(value ? [value] : []);
            return undefined;
        }

        fetch({ filter: {
                query: inputValue, 
                filters: JSON.stringify([{ field: 'regular_users', op: 'null', value: true }])
            } }, (res) => {
            console.log('user res', res, active);
            if (active) {
                let newOptions = [];
                if (value) {
                    newOptions = [value];
                }
                if (res.data) {
                    newOptions = [...newOptions, ...res.data];
                }
                console.log('new options', newOptions);
                setOptions(newOptions);
            }
        });
            // .then(res => {
                // if (active) {
                //     let newOptions = [];
                //     if (value) {
                //         newOptions = [value];
                //     }
                //     if (res.data) {
                //         newOptions = [...newOptions, ...res.data];
                //     }
                //     setOptions(newOptions);
                // }
            // });
        return () => {
            active = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);

    console.log('render', options);
    return (<div ref={ref} className={classes.paper}>
        <Box mb={2}>
            <Typography variant="h6">Select users to add as staff</Typography>
        </Box>
        <Autocomplete
            getOptionLabel={(opt) => opt.display_name}
            options={options}
            autoComplete
            includeInputInList
            filterOptions={(options, state) => { return options; }}
            filterSelectedOptions
            value={value}
            onChange={(ev, newValue) => {
                console.log('onChange', newValue);
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                props.onSelect && props.onSelect(newValue);
            }}
            onInputChange={(ev, newInputValue) => { setInputValue(newInputValue); }}
            renderInput={(params) => (<TextField {...params} autoFocus label="Search for user" variant="outlined" fullWidth/>)}
            renderOption={(opt) => {
                console.log('option', opt);
                return (
                    <Grid container alignItems="center">
                        <Grid item>
                            <Typography variant="body2" color="textSecondary">{opt.display_name}</Typography>
                        </Grid>
                    </Grid>
                );
            }}
            />
      </div>

    );
});
const UserRolesListToolbar = (props) => {
    const createBt = React.useRef(null);
    const deleteBt = React.useRef(null);
    const searchQueryRef = React.useRef(null);
    const [userSearchOpen, setUserSearchOpen] = React.useState(false);
    const theme = useTheme();
    // const btSize = props.isSmallScreen ? "medium" : "small";
    // const dataAPI = React.useContext(DataAPIContext);
    // const history = useHistory();
    // const classes = useToolbarStyles();
    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value)
    };

    const onAddStaffUserBtClick = (ev) => {
        setUserSearchOpen(true);
    }

    const onUserSearchClose = () => {
        setUserSearchOpen(false);
    }

    const onNewUserSelected = (user) => {
        setUserSearchOpen(false);
        props.onAddNewUser && props.onAddNewUser(user);
    }

    const onDeleteStaffUserBtClick = (ev) => {
        props.onDeleteUsers && props.onDeleteUsers(props.selectedIds);
    }

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => (props.onQueryChange && props.onQueryChange(query));


    return (<Toolbar disableGutters={true}>
        <Grid container direction="row">
            <Grid item xs={8} sm={4}>
                <TextField 
                    variant="filled" 
                    label="Search" 
                    size="small"
                    onChange={debouncedSearchQueryChangeHandler}
                    inputRef={searchQueryRef}
                    fullWidth
                    InputProps={{
                        endAdornment: (<InputAdornment position="end">
                            <IconButton aria-label="do search" onClick={handleSearchQueryChange}><SearchIcon/></IconButton>
                        </InputAdornment>)
                    }}
                    />
            </Grid>
            <Grid item xs={4} sm={8} container justifyContent="flex-end" alignItems="center">
                { props.isSmallScreen ? null : 
                    <React.Fragment>
                        { props.selectedIds && props.selectedIds.length > 0 ?
                        <Box mr={2} display="inline">
                            <DeleteButton ref={deleteBt} perm="user.write" size="small" onClick={onDeleteStaffUserBtClick}>
                                Delete staff user{ props.selectedIds.length > 1 ? "s" : "" }
                            </DeleteButton>
                        </Box>
                        : null }
                        { props.canWrite ?
                        <Box direction="row-reverse" display="inline">
                            <Button ref={createBt} color="primary" variant="contained" size="small" onClick={onAddStaffUserBtClick}>
                                <AddIcon/>&nbsp;Add staff user
                            </Button>
                        </Box>
                        : null }
                    </React.Fragment>
                }
            </Grid>
        </Grid>
        { props.canWrite && props.isSmallScreen && !userSearchOpen ?
            <Box position="fixed" right={theme.spacing(3)} bottom={theme.spacing(3)} zIndex={99000}>
                <Fab color="primary" onClick={onAddStaffUserBtClick}><AddIcon/></Fab>
            </Box>
        : null }
        <Modal
            open={userSearchOpen}
            onClose={onUserSearchClose}
            >
                <UserSearchModal onSelect={onNewUserSelected}/>
            </Modal>
    </Toolbar>);
}


const RoleEditInputCell = (props) => {

    // eslint-disable-next-line no-unused-vars
    const { id, value, api, field, row } = props;
    const [selectedIds, setSelectedIds] = React.useState(props.row.role);
    const rootRef = React.useRef(null);

    const classes = useStyles();
    const handleChange = (ev) => {
        const id = +ev.target.name;
        if (ev.target.checked) {
            setSelectedIds([...selectedIds, id]);
        } else {
            const newIds = [...selectedIds];
            newIds.splice(selectedIds.indexOf(id), 1);
            setSelectedIds(newIds);
        }
    }

    const onConfirm = () => {
        // console.log('confirming', props.row.id, field, selectedIds);
        api.commitCellChange({ id, field, props: { value: selectedIds} });
        api.setCellMode(id, field, 'view');
        props.onChange && props.onChange(props.row.id, selectedIds, props.rowIndex);
    }

    const onCancel = () => {
        api.setCellMode(id, field, 'view');
    }

    return (
        <Grid container direction="row">
            <Grid item xs={10} container alignItems="center">
        <FormGroup ref={rootRef} row className={classes.formGroup}>
            {Object.keys(props.roles || {}).map(id => (
                <FormControlLabel
                    key={id}
                    control={
                        <Switch
                            size="small"
                            className={classes.switch}
                            checked={selectedIds.indexOf(+id) >= 0}
                            color="primary"
                            name={id}
                            onChange={handleChange}
                            />
                    }
                    label={<Typography className={classes.switchLabel}>{props.roles[id].name}</Typography>}
                />
            ))}
        </FormGroup>
            </Grid>
            <Grid item xs={2}>
                <IconButton color="secondary" size="small" onClick={onCancel}><CloseIcon/></IconButton>
                <IconButton color="primary" size="small" onClick={onConfirm}><DoneIcon/></IconButton>
            </Grid>
        </Grid>
    )
}

const UserRoleManagement= (props) => {
    const dataAPI = React.useContext(DataAPIContext);
    const resource = "tour_operator_user";
    const classes = useStyles();
    const [query, setQuery] = React.useState(null);
    const [roles, setRoles] = React.useState({});
    const [lastUpdate, setLastUpdate] = React.useState(null);
    const [syncActive, setSyncActive] = React.useState(false);
    const [showSelectRoleDialog, setShowSelectRoleDialog] = React.useState(null);
    const [roleToAdd, setRoleToAdd] = React.useState(null);
    const [selectedIds, setSelectedIds] = React.useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const isSmallScreen = !useIsWidthUp('sm');
    // WP-K: the same gate as the Users pages (users/UserEdit.js); the backend enforces it.
    const { hasPerm } = React.useContext(ContextStore);
    const canWrite = hasPerm('user', 'write');

    const convert =  (data) => {
        const rmap = {};
        (data.roles || []).forEach(r => (rmap[r.id] = r));
        setRoles(rmap);
        return data.users;
    };

    const onRolesChange = (id, value) => {
        console.log('onRolesChange', id, value);

        setSyncActive(true);
        // keepSessionOn403: a refusal is an answer here, not an expired session.
        dataAPI(UPDATE, resource, { id: id, data: { role: value }, keepSessionOn403: true })
            .then(res => {
                console.log('update res', res);
                if (isOk(res)) {
                    enqueueSnackbar("User roles updated", { variant: 'success' });
                } else {
                    enqueueSnackbar(staffChangeError(res, "Error updating user roles"), { variant: 'error' });
                }
            })
            .catch(() => enqueueSnackbar("Error updating user roles", { variant: 'error' }))
            .finally(() => {
                // After a refusal too: the grid already shows the edit, the reload puts the stored roles back.
                setLastUpdate((new Date()).toString());
                setSyncActive(false);
            });
    }

    const onAddNewUser = (user) => {
        setSyncActive(true);
        dataAPI(CREATE, resource, { data: { id: user.id }, keepSessionOn403: true })
            .then(res => {
                console.log('add res', res);
                if (isOk(res)) {
                    setLastUpdate((new Date()).toString());
                    enqueueSnackbar("User added to staff", { variant: 'success' });
                } else {
                    enqueueSnackbar(serverErrorMessage(res, "Error adding the staff user"), { variant: 'error' });
                }
            })
            .catch(() => enqueueSnackbar("Error adding the staff user", { variant: 'error' }))
            .finally(() => { setSyncActive(false); });
    }

    const onDeleteUsers = (idlist) => {
        setSyncActive(true);
        dataAPI(DELETE_BATCH, resource, { data: { list: idlist }, keepSessionOn403: true })
            .then(res => {
                console.log('delete res', res);
                if (isOk(res)) {
                    setLastUpdate((new Date()).toString());
                    setSelectedIds([]);
                    enqueueSnackbar("User removed from staff", { variant: 'default' });
                } else {
                    enqueueSnackbar(staffChangeError(res, "Error removing the staff user"), { variant: 'error' });
                }
            })
            .catch(() => enqueueSnackbar("Error removing the staff user", { variant: 'error' }))
            .finally(() => { setSyncActive(false); });
    }

    const onQueryChange = (query) => {
        setQuery(query);
    }

    const onSelectionModelChange = (ids, selection) => {
        console.log('onSelectionModelChange', ids, selection);
        setSelectedIds(ids);
    }

    const deleteUser = (row, ev) => {
        return onDeleteUsers([row.id]);
    }

    const deleteRole = (row, rid, ev) => {
        console.log('delete role', row, rid);
        const roles = [...(row.role || [])];
        roles.splice(roles.indexOf(rid), 1);
        // console.log(row.role, roles);
        onRolesChange(row.id, roles);
    }

    const addRole = (row, ev) => {
        console.log('add role', row);
        setShowSelectRoleDialog(row);
    }

    const confirmationDialogCancel = () => {
        setShowSelectRoleDialog(null);
        setRoleToAdd(null);
    }
    const confirmationDialogConfirm = () => {
        console.log('confirm', roleToAdd);
        const roles = [...showSelectRoleDialog.role];
        roles.push(+roleToAdd);
        onRolesChange(showSelectRoleDialog.id, roles);
        confirmationDialogCancel();
    }

    const listItemRenderer = (row, idx, rows, gridApi) => {
        const roleList = (row.role || []).map(r => roles[r]);
        // console.log('renderCell', p, roleList, p.value);
    
        return <React.Fragment key={idx}>
            <ListItem alignItems="flex-start" className={classes.listItem} onClick={(ev) => gridApi.onRowClick({ row, idx }, ev)}>
                <ListItemText
                    primary={<React.Fragment>
                        <Grid container direction="row">
                            <Grid item xs={10}>
                                <Typography>{row.user.login}</Typography>
                            </Grid>
                            <Grid item xs={2} container justifyContent="flex-end" alignItems="center">
                                <DeleteIconButton title="Delete staff user" perm="user.write" onClick={ev => deleteUser(row, ev)} />
                            </Grid>
                        </Grid>
                    </React.Fragment>}
                    // the role chips are divs: a <p> may not hold them
                    secondaryTypographyProps={{ component: 'div' }}
                    secondary={<React.Fragment key={row.id}>
                        {(roleList || []).map(e => (
                            <Chip key={e.id} className={classes.chip} label={e.name} onDelete={canWrite ? (ev) => deleteRole(row, e.id, ev) : undefined}/>
                        )) }
                        { canWrite && roleList.length < Object.keys(roles).length ?
                            <Chip key={'add'} color="primary" className={classes.chip} label={<AddIcon/>} onClick={ev => addRole(row, ev)}/>
                        : null }
                    </React.Fragment>}
                />
            </ListItem>
            { idx < rows.length - 1 ? <Divider/> : null }
        </React.Fragment>;
    }

    const filteredRoles = !showSelectRoleDialog ? null : Object.keys(roles)
        .filter(rid => showSelectRoleDialog.role.indexOf(+rid) < 0);
    if (!roleToAdd && filteredRoles && filteredRoles.length > 0) {
        setRoleToAdd(filteredRoles[0]);
    }
    const roleItems = !filteredRoles ? null : filteredRoles
        .map(rid => <option key={+rid} value={+rid}>{roles[rid].name}</option>);
    // const test = [
    //     <option key={1}>a</option>,
    //     <option key={2}>b</option>,
    //     <option key={3}>c</option>
    // ];
    console.log('UserRoles', roleToAdd);

    return (<div className={classes.root}>
        <PageMeta title="User Roles"/>
        { showSelectRoleDialog && filteredRoles && filteredRoles.length > 0 ?
            <ConfirmationDialog
                classes={{ paper: classes.paper }}
                keepMounted
                onCancel={confirmationDialogCancel}
                onConfirm={confirmationDialogConfirm}
                title="Please select a role to add"
                okButtonText="Add role"
                cancelButtonText="Cancel"
                open={!!showSelectRoleDialog}
            >
                <FormControl variant="filled" size="small" fullWidth>
                    <InputLabel>Role</InputLabel>
                    <Select 
                        native 
                        value={Object.keys(roles)[0]}
                        onChange={ev => { console.log(ev.target.value); setRoleToAdd(+ev.target.value) }}
                        inputProps={{
                            name: 'role',
                            id: 'add-role-select',
                          }}
                        >
                        {roleItems}
                    </Select>
                </FormControl>                                        
                
            </ConfirmationDialog>
            : null }
        <Grid container direction="row" className={classes.gridRoot}>
            <Grid item xs={12}>
                <LinearProgress color="primary" className={classes.progress} style={{ visibility: syncActive ? 'visible' : 'hidden' }}/>
                <UserRolesListToolbar
                    resource={resource}
                    selectedIds={selectedIds}
                    onQueryChange={onQueryChange}
                    onAddNewUser={onAddNewUser}
                    onDeleteUsers={onDeleteUsers}
                    isSmallScreen={isSmallScreen}
                    canWrite={canWrite}
                    />
                <RecordList
                className={classes.recordList}
                resource={resource}
                disableSelectionOnClick={true}
                onSelectionModelChange={onSelectionModelChange}
                sortModel={[{ field: 'name', sort: 'asc' }]}
                deps={lastUpdate}
                query={query}
                convert={convert}
                isSmallScreen={isSmallScreen}
                listItemRenderer={listItemRenderer}
                columns={[
                    { field: 'login', headerName: 'User', sortable: false, flex: 1, valueGetter: (p) => p.row.user.login },
                    {
                        field: 'role',
                        headerName: 'Roles',
                        sortable: false,
                        editable: canWrite,
                        flex: 1,
                        valueGetter: (p) => (p.row.role),
                        renderEditCell: (params) => (<RoleEditInputCell {...params} roles={roles} onChange={onRolesChange}/>),
                        renderCell: (p) => {
                            const roleList = (p.value || []).map(r => roles[r]);
                            // console.log('renderCell', p, roleList, p.value);
                            return (<React.Fragment key={p.row.id}>
                                {(roleList || []).map(e => (<Chip key={e.id} className={classes.chip} label={e.name}/>)) }
                            </React.Fragment>);
                        }
                    }
                ]}
                />
            </Grid>
        </Grid>
    </div>);
}

export default UserRoleManagement;
